/* Casa Blend UI helpers.
   1. Dot indicators under mobile product carousels (Dawn hides its arrows there).
   2. "See more" clamp on the product description.
   Both are defensive: they never write into a node they observe, and they bail
   out quietly if the markup is not what they expect. */
(function () {
  'use strict';

  /* ---------------------------------------------------------- dots ------ */
  function dots(comp) {
    if (comp.dataset.cbDots) return;

    /* The product media gallery already has thumbnails; dots there are noise. */
    if (comp.closest && comp.closest('media-gallery, .product__media-wrapper, .product__media-list, .thumbnail-slider')) return;

    var slider = comp.querySelector('.slider');
    if (!slider) return;
    comp.dataset.cbDots = '1';

    var wrap = document.createElement('div');
    wrap.className = 'cb-dots';
    wrap.setAttribute('aria-hidden', 'true');
    comp.appendChild(wrap);

    var n = 0;

    function render() {
      var w = slider.clientWidth || 1;
      var count = Math.round(slider.scrollWidth / w);
      if (count < 1) count = 1;
      if (count > 12) count = 12;

      if (count !== n) {
        n = count;
        wrap.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var d = document.createElement('span');
          d.className = 'cb-dot';
          wrap.appendChild(d);
        }
      }
      wrap.hidden = n < 2;
      if (n < 2) return;

      var idx = Math.round(slider.scrollLeft / w);
      if (idx < 0) idx = 0;
      if (idx > n - 1) idx = n - 1;
      for (var j = 0; j < wrap.children.length; j++) {
        wrap.children[j].classList.toggle('is-on', j === idx);
      }
    }

    var t = 0;
    function schedule(ms) {
      if (t) clearTimeout(t);
      t = setTimeout(function () { t = 0; render(); }, ms);
    }

    slider.addEventListener('scroll', function () { if (!t) schedule(70); }, { passive: true });
    window.addEventListener('resize', function () { schedule(160); }, { passive: true });
    render();
  }

  /* ------------------------------------------------- description clamp -- */
  function clamp() {
    var d = document.querySelector('.product__description');
    if (!d || d.dataset.cbClamp) return;
    d.dataset.cbClamp = '1';

    d.classList.add('cb-clamp');

    if (d.scrollHeight <= d.clientHeight + 8) {
      d.classList.remove('cb-clamp');
      return;
    }

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cb-more';
    b.textContent = 'See more';
    b.setAttribute('aria-expanded', 'false');
    if (d.parentNode) d.parentNode.insertBefore(b, d.nextSibling);

    b.addEventListener('click', function () {
      var open = d.classList.toggle('cb-clamp--open');
      b.textContent = open ? 'See less' : 'See more';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open && b.getBoundingClientRect().top < 0) {
        d.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    });
  }

  /* ---------------------------------------------------------- boot ------ */
  function boot() {
    try {
      var list = document.querySelectorAll('slider-component');
      for (var i = 0; i < list.length; i++) dots(list[i]);
    } catch (e) { /* never block the page */ }
    try { clamp(); } catch (e) { /* ditto */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
